import { defineComponent } from "@/utils/define-component";

/**
 * create and append loading-css
 */
const css = "body.is-loading * { cursor: wait; }";
const style = document.createElement("style");
style.appendChild(document.createTextNode(css));
document.head.appendChild(style);

const loadingInstances = new Map();

export default defineComponent(() => ({
  isLoading: false,

  setIsLoading(e: CustomEvent) {
    const { id, isLoading: isLoadingState } = e.detail;
    loadingInstances.set(id, isLoadingState);

    const somethingIsLoading = [...loadingInstances.values()].find(Boolean);
    document.body.classList.toggle("is-loading", !!somethingIsLoading);

    this.isLoading = somethingIsLoading
  },

  clearLoading() {
    loadingInstances.clear();

    document.body.classList.toggle("is-loading", false);
    this.isLoading = false;
  },
}));
